module.exports = __webpack_public_path__ + "static/placeholder-timeline2-4286d959a95949a2a8ab72524da254f0.svg";